// extracted by mini-css-extract-plugin
export default {"googlePhotosIcon":"dk7gv0"};